import { render, staticRenderFns } from "./PaymentOrderPickup.vue?vue&type=template&id=5a37b006"
import script from "./PaymentOrderPickup.vue?vue&type=script&lang=js"
export * from "./PaymentOrderPickup.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderPickup.vue?vue&type=style&index=0&id=5a37b006&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports